import { css } from 'lit';

export const appStyles = css`
  :host {
    display: block;
    height: 100dvh;
    min-height: 100dvh;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    overflow: visible;
    background: linear-gradient(to bottom, var(--bg-primary), var(--bg-secondary));
    box-shadow: none;
  }

  #outlet {
    display: block;
    height: 100%;
    width: 100%;
    min-height: 100%;
    overflow: visible;
    box-sizing: border-box;
  }

  #outlet > * {
    box-shadow: none;
  }
`;
